export default __webpack_public_path__ + "static/11-739d5e249e2fc6b87cb61a001e6646c0.png";